module.exports = __webpack_public_path__ + "static/media/zenodo-dropdown.53933fe7.png";